import { useQuery } from "@tanstack/react-query";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { InventoryManagerListItem } from "../../inventory.types";
import { requestGetInventoryManagers } from "./getInventoryManagers.request";

const useGetInventoryManagersList = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<
    GetListResponse<InventoryManagerListItem>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["inventory-manager", "all", requestParams],
    queryFn: async () => await requestGetInventoryManagers(requestParams),
    ...options
  });

  return { inventoryManagersList: data?.data, meta: data?.meta, ...rest };
};

export default useGetInventoryManagersList;
